var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 201,
    viewBox: "0 0 161 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_4912)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.650513,
    width: 160,
    height: 200,
    rx: 8,
    fill: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.528 179.301V174.997H26.088V173.461H19.528V170.133H26.328V168.581H17.8V179.301H19.528ZM30.9245 179.461C32.9725 179.461 34.0285 178.181 34.2845 176.837H34.3805V179.301H35.9645V171.349H34.2525V175.285C34.2525 177.013 33.4365 177.909 31.6765 177.909C29.9965 177.909 29.3085 177.157 29.3085 175.669V171.349H27.5965V176.133C27.5965 177.973 28.6845 179.461 30.9245 179.461ZM39.2624 179.301V175.365C39.2624 173.637 40.0464 172.741 41.7904 172.741C43.4384 172.741 44.1104 173.493 44.1104 174.981V179.301H45.8384V174.517C45.8384 172.677 44.7504 171.189 42.5424 171.189C40.5264 171.189 39.4704 172.469 39.2304 173.813H39.1184V171.349H37.5344V179.301H39.2624ZM50.8821 179.461C52.6741 179.461 53.8421 178.597 54.1781 177.013H54.2901V179.301H55.8741V168.581H54.1461V173.509H54.0501C53.7301 172.165 52.6581 171.189 50.7701 171.189C48.3541 171.189 46.9781 172.853 46.9781 175.333C46.9781 177.781 48.3701 179.461 50.8821 179.461ZM48.7221 175.333C48.7221 173.413 49.7141 172.757 51.3781 172.757C53.1541 172.757 54.1461 173.589 54.1461 175.285V175.413C54.1461 177.077 53.1061 177.877 51.4101 177.877C49.6981 177.877 48.7221 177.237 48.7221 175.333ZM61.2319 179.461C63.4719 179.461 64.9439 178.581 64.9439 177.093C64.9439 175.781 64.0799 175.141 62.1919 174.901L60.3519 174.645C59.1519 174.485 58.8319 174.261 58.8319 173.637C58.8319 172.885 59.3439 172.565 60.7999 172.565C62.5599 172.565 63.0399 173.061 63.0399 174.005V174.101H64.7519V174.053C64.7519 172.165 63.2799 171.189 60.8479 171.189C58.3999 171.189 57.1359 172.181 57.1359 173.573C57.1359 174.901 58.0479 175.541 59.5519 175.733L61.7279 176.021C62.8639 176.181 63.2479 176.389 63.2479 177.045C63.2479 177.749 62.7839 178.069 61.2319 178.069C59.5679 178.069 58.9439 177.733 58.9439 176.693V176.565H57.2159V176.613C57.2159 178.453 58.6719 179.461 61.2319 179.461ZM74.141 179.301V177.749H72.701C71.709 177.749 71.261 177.493 71.261 176.517V172.789H74.141V171.349H71.261V169.605H69.549V171.349H68.205V172.789H69.549V176.613C69.549 178.549 70.605 179.301 72.317 179.301H74.141ZM76.9499 179.301V174.837C76.9499 173.413 77.5099 172.661 78.8699 172.661C80.0539 172.661 80.5339 173.189 80.5339 174.325V175.029H82.2459V173.989C82.2459 172.485 81.4619 171.189 79.6539 171.189C78.0219 171.189 77.1579 172.213 76.9179 173.493H76.8059V171.349H75.2219V179.301H76.9499ZM85.6673 179.461C87.4753 179.461 88.7393 178.661 89.1553 177.317H89.2673V179.301H90.8513V174.469C90.8513 172.565 89.7153 171.189 87.1873 171.189C84.6593 171.189 83.1553 172.549 83.1553 174.357V174.421H84.8673V174.357C84.8673 173.189 85.5873 172.709 87.0593 172.709C88.5793 172.709 89.1553 173.173 89.1553 174.485V174.949L85.5393 175.333C83.9713 175.509 82.9793 176.149 82.9793 177.381C82.9793 178.693 84.0193 179.461 85.6673 179.461ZM84.7073 177.269C84.7073 176.645 85.1393 176.437 86.0353 176.325L89.1553 175.973C89.1553 177.541 87.9393 178.213 86.1313 178.213C85.1393 178.213 84.7073 177.909 84.7073 177.269ZM94.1218 179.301V175.365C94.1218 173.637 94.9058 172.741 96.6498 172.741C98.2978 172.741 98.9698 173.493 98.9698 174.981V179.301H100.698V174.517C100.698 172.677 99.6098 171.189 97.4018 171.189C95.3858 171.189 94.3298 172.469 94.0898 173.813H93.9778V171.349H92.3938V179.301H94.1218ZM105.998 179.461C108.238 179.461 109.71 178.581 109.71 177.093C109.71 175.781 108.846 175.141 106.958 174.901L105.118 174.645C103.918 174.485 103.598 174.261 103.598 173.637C103.598 172.885 104.11 172.565 105.566 172.565C107.326 172.565 107.806 173.061 107.806 174.005V174.101H109.517V174.053C109.517 172.165 108.046 171.189 105.614 171.189C103.166 171.189 101.902 172.181 101.902 173.573C101.902 174.901 102.814 175.541 104.318 175.733L106.494 176.021C107.63 176.181 108.014 176.389 108.014 177.045C108.014 177.749 107.55 178.069 105.998 178.069C104.334 178.069 103.71 177.733 103.71 176.693V176.565H101.982V176.613C101.982 178.453 103.438 179.461 105.998 179.461ZM113.292 179.301V172.789H116.14V171.349H113.26C113.164 170.197 113.82 169.861 115.084 169.861H116.14V168.581H115.356C113.1 168.581 111.772 169.605 111.58 171.349H110.364V172.789H111.564V179.301H113.292ZM121.097 179.461C123.465 179.461 125.129 178.293 125.129 176.597V176.453H123.401V176.581C123.401 177.525 122.713 178.069 121.049 178.069C119.209 178.069 118.457 177.253 118.393 175.717H125.145C125.193 175.477 125.209 175.253 125.209 174.965C125.209 172.549 123.529 171.189 121.065 171.189C118.473 171.189 116.777 172.853 116.777 175.333C116.777 177.989 118.489 179.461 121.097 179.461ZM121.033 172.549C122.729 172.549 123.577 173.253 123.577 174.725V174.757H118.409C118.505 173.333 119.273 172.549 121.033 172.549ZM128.231 179.301V174.837C128.231 173.413 128.791 172.661 130.151 172.661C131.335 172.661 131.815 173.189 131.815 174.325V175.029H133.527V173.989C133.527 172.485 132.743 171.189 130.935 171.189C129.303 171.189 128.439 172.213 128.199 173.493H128.087V171.349H126.503V179.301H128.231Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 28.8237,
    y1: 131.118,
    x2: 28.8237,
    y2: -10.3968,
    stroke: "url(#paint0_linear_75_4912)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.8237,
    y1: 131.118,
    x2: 64.8237,
    y2: -10.3968,
    stroke: "url(#paint1_linear_75_4912)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100.824,
    y1: 131.118,
    x2: 100.824,
    y2: -10.3968,
    stroke: "url(#paint2_linear_75_4912)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.824,
    y1: 131.118,
    x2: 135.824,
    y2: -10.3968,
    stroke: "url(#paint3_linear_75_4912)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.1421,
    y1: 29.9794,
    x2: 198.245,
    y2: 29.9793,
    stroke: "url(#paint4_linear_75_4912)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.1421,
    y1: 88.9794,
    x2: 198.245,
    y2: 88.9793,
    stroke: "url(#paint5_linear_75_4912)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -60.1421,
    y1: 58.9794,
    x2: 198.245,
    y2: 58.9793,
    stroke: "url(#paint6_linear_75_4912)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17.1505,
    width: 71,
    height: 71,
    rx: 35.5,
    fill: "url(#paint7_linear_75_4912)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_75_4912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9736 62.7971C34.9736 62.045 35.5833 61.4353 36.3354 61.4353H60.847C61.5991 61.4353 62.2088 62.045 62.2088 62.7971C62.2088 63.5491 61.5991 64.1588 60.847 64.1588H36.3354C35.5833 64.1588 34.9736 63.5491 34.9736 62.7971ZM37.6971 51.903C37.6971 51.1509 38.3068 50.5413 39.0589 50.5413C39.811 50.5413 40.4207 51.1509 40.4207 51.903V58.7118C40.4207 59.4639 39.811 60.0736 39.0589 60.0736C38.3068 60.0736 37.6971 59.4639 37.6971 58.7118V51.903ZM44.5059 51.903C44.5059 51.1509 45.1156 50.5413 45.8677 50.5413C46.6198 50.5413 47.2294 51.1509 47.2294 51.903V58.7118C47.2294 59.4639 46.6198 60.0736 45.8677 60.0736C45.1156 60.0736 44.5059 59.4639 44.5059 58.7118V51.903ZM49.9529 51.903C49.9529 51.1509 50.5626 50.5413 51.3147 50.5413C52.0668 50.5413 52.6765 51.1509 52.6765 51.903V58.7118C52.6765 59.4639 52.0668 60.0736 51.3147 60.0736C50.5626 60.0736 49.9529 59.4639 49.9529 58.7118V51.903ZM56.7617 51.903C56.7617 51.1509 57.3714 50.5413 58.1235 50.5413C58.8756 50.5413 59.4852 51.1509 59.4852 51.903V58.7118C59.4852 59.4639 58.8756 60.0736 58.1235 60.0736C57.3714 60.0736 56.7617 59.4639 56.7617 58.7118V51.903ZM34.9736 45.2287C34.9736 44.3117 35.4917 43.4734 36.3119 43.0634L47.5085 37.465C48.1901 37.1243 48.9923 37.1243 49.6739 37.465L60.8705 43.0634C61.6907 43.4734 62.2088 44.3117 62.2088 45.2287V46.7586C62.2088 48.0956 61.1249 49.1795 59.7879 49.1795H37.3945C36.0575 49.1795 34.9736 48.0956 34.9736 46.7586V45.2287ZM48.5912 45.0942C48.9524 45.0942 49.2987 44.9508 49.5541 44.6954C49.8095 44.44 49.9529 44.0936 49.9529 43.7325C49.9529 43.3713 49.8095 43.025 49.5541 42.7696C49.2987 42.5142 48.9524 42.3707 48.5912 42.3707C48.23 42.3707 47.8837 42.5142 47.6283 42.7696C47.3729 43.025 47.2294 43.3713 47.2294 43.7325C47.2294 44.0936 47.3729 44.44 47.6283 44.6954C47.8837 44.9508 48.23 45.0942 48.5912 45.0942Z",
    fill: "#4583FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2367 53.0021L56.2374 53.0023C61.3078 54.4768 66.0892 56.8062 70.3756 59.8901L56.2367 53.0021ZM56.2367 53.0021C55.9662 52.9237 55.6794 52.9198 55.4069 52.991C55.1343 53.0621 54.8861 53.2056 54.6884 53.4063C54.4907 53.6069 54.351 53.8573 54.2839 54.1309C54.2169 54.4045 54.225 54.6911 54.3075 54.9605L54.3079 54.9616M56.2367 53.0021L54.3079 54.9616M54.3079 54.9616L56.1319 60.8904L56.2145 61.1588M54.3079 54.9616L56.2145 61.1588M56.2145 61.1588L56.1319 61.4273L54.3079 67.356L54.3075 67.3572C54.225 67.6265 54.2169 67.9131 54.2839 68.1867C54.351 68.4603 54.4907 68.7107 54.6884 68.9114C54.8861 69.112 55.1343 69.2555 55.4069 69.3267M56.2145 61.1588L70.376 62.4273C66.0895 65.5113 61.308 67.8407 56.2374 69.3153L56.2367 69.3155C55.9662 69.3939 55.6795 69.3978 55.4069 69.3267M55.4069 69.3267C55.4069 69.3267 55.4069 69.3267 55.4069 69.3267L55.6595 68.3591L55.4069 69.3267ZM69.9642 61.4155L70.854 61.8717C70.9671 61.6511 71.0261 61.4067 71.0261 61.1588C71.0261 60.9109 70.9671 60.6665 70.854 60.4459L70.854 60.4459C70.741 60.2254 70.5771 60.035 70.376 59.8903L69.9642 61.4155Z",
    fill: "#C1D6FF",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17.1505,
    width: 71,
    height: 71,
    rx: 35.5,
    stroke: "url(#paint8_linear_75_4912)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_4912",
    x1: 29.3237,
    y1: 9.68107,
    x2: 29.3238,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_4912",
    x1: 65.3237,
    y1: 9.68107,
    x2: 65.3238,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_4912",
    x1: 101.324,
    y1: 9.68107,
    x2: 101.324,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_4912",
    x1: 136.324,
    y1: 9.68107,
    x2: 136.324,
    y2: 154.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_4912",
    x1: -60.1421,
    y1: 30.4794,
    x2: 195.012,
    y2: 30.4794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_75_4912",
    x1: -60.1421,
    y1: 89.4794,
    x2: 195.012,
    y2: 89.4794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_75_4912",
    x1: -60.1421,
    y1: 59.4794,
    x2: 195.012,
    y2: 59.4794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_75_4912",
    x1: 52.5,
    y1: 16.6505,
    x2: 52.5,
    y2: 88.6505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_75_4912",
    x1: 52.5,
    y1: 16.6505,
    x2: 52.5,
    y2: 88.6505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_4912"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.650513,
    width: 160,
    height: 200,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_75_4912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(31.5 31.6505)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact3);
export default __webpack_public_path__ + "static/media/contact3.63ff6c9543a594b6c92778b0c76eef21.svg";
export { ForwardRef as ReactComponent };